<template>
    <div class="form-group">
        <label v-if="label" class="form-label" :for="id">{{ label }}</label>
        <select :class="class" :id="id" :name="name" :disabled="disabled" :required="required"
            style="width: 100%;"></select>
        <span v-if="error" style="color:#dc3545; font-size:80%">{{ error }}</span>
    </div>
</template>
  
<script>
// https://github.com/godbasin/vue-select2/blob/npm-publish-code-for-vue3/src/Select2.vue
import { v4 as uuid } from 'uuid'
export default {
    data() {
        return {
            select2: null
        };
    },
    emits: ['update:modelValue'],
    props: {
        modelValue: [String, Array], // previously was `value: String`
        id: {
            type: String,
            default() {
                return `input-select2-${uuid()}`
            },
        },
        name: {
            type: String,
            default: ''
        },
        placeholder: {
            type: String,
            default: ''
        },
        options: {
            type: Array,
            default: () => []
        },
        disabled: {
            type: Boolean,
            default: false
        },
        required: {
            type: Boolean,
            default: false
        },
        settings: {
            type: Object,
            default: () => { }
        },
        label: String,
        error: String,
        class: {
            type: String,
            default: 'form-control',
        },
    },
    watch: {
        options: {
            handler(val) {
                this.setOption(val);
            },
            deep: true
        },
        modelValue: {
            handler(val) {
                this.setValue(val);
            },
            deep: true
        },
    },
    methods: {
        setOption(val = []) {
            this.select2.empty();
            this.select2.select2({
                placeholder: this.placeholder,
                ...this.settings,
                data: val
            });
            this.setValue(this.modelValue);
        },
        setValue(val) {
            if (val instanceof Array) {
                this.select2.val([...val]);
            } else {
                this.select2.val([val]);
            }
            this.select2.trigger('change');
        }
    },
    mounted() {
        this.select2 = $(this.$el)
            .find('select')
            .select2({
                placeholder: this.placeholder,
                ...this.settings,
                data: this.options
            })
            .on('select2:select select2:unselect', ev => {
                this.$emit('update:modelValue', this.select2.val());
                // this.$emit('select', ev['params']['data']);
            });
        this.setValue(this.modelValue);
    },
    beforeUnmount() {
        this.select2.select2('destroy');
    }
};
</script>